import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { CONTAINER_TYPES } from "../../infrastructure/ioc/container-types";
import ServiceInterface from "@/vue/service/service-interface";
import DfPromotion from "@/vue/domain/promotion/df-promotion";
import moment from "moment";
import Utils from "@/vue/infrastructure/utils/helpers";
import DfStore from "@/vue/domain/store/df-store";
import DfContent from "@/vue/domain/content/df-content";

@Component({
  filters: {
    dateFormat(value: Date | string): string {
      return value != null ? moment(value, Utils.ISO_8601_STRING_PATTERN).format(Utils.DATE_STRING_PATTER) : "";
    },
  },
})
export default class DfPromotionCardComponent extends Vue {
  @Inject(CONTAINER_TYPES.ServiceInterface)
  private service!: ServiceInterface;

  @Prop({ type: Object, default: () => ({}) })
  promotion!: DfPromotion;

  get flyer(): Array<DfContent> {
    return this.$store.getters.storeContents.filter((content: DfContent) => content.type.code === "FLY" && content.promotion == this.promotion.identifier)[0];
  }

  get promotionDateStart(): string {
    return this.promotion ? this.$options.filters!.dateFormat(this.promotion.startDate) : null;
  }

  get promotionDateEnd(): string {
    return this.promotion ? this.$options.filters!.dateFormat(this.promotion.endDate) : null;
  }

  get currentStore(): DfStore {
    return this.$store.getters.currentStore;
  }

  private onClick() {
    if (this.pdf) {
      window.open(this.pdf, "_blank");
    } else if (this.url) {
      window.open(this.url, "_blank");
    } else {
      Utils.setAnaliticsTraker({
        event: "open-promotion",
        origin: "smt-digitalflyer-ui",
        promotionAlias: this.promotion.alias,
        promotionBeginDate: this.promotion.startDate,
        promotionCode: this.promotion.code,
        promotionDescription: this.promotion.description,
        promotionEndDate: this.promotion.endDate,
        storeAlias: this.currentStore.alias,
        storeCode: this.currentStore.code,
        storeName: this.currentStore.name,
      });
      this.$router.push({ name: "promotion", params: { storeAlias: this.currentStore.alias, promotionAlias: this.promotion.alias } });
    }
  }

  get promotionPreview(): string {
    const promotionPreview: string = Utils.getPropertyImageUrl(this.promotion, Utils.PROPERTY_PREVIEW, null);
    return promotionPreview ? `url(${encodeURI(promotionPreview)})` : null;
  }

  get flyerPreview(): string {
    const flyerPreview: string = Utils.getPropertyImageUrl(this.flyer, Utils.PROPERTY_PREVIEW, null);
    return flyerPreview ? `url(${encodeURI(flyerPreview)})` : null;
  }

  get preview(): string {
    const preview: string = this.flyerPreview || this.promotionPreview || "";
    return preview.replace(/'/g, "%27");
  }

  get pdf(): string {
    return Utils.getPropertyImageUrl(this.promotion, Utils.PROPERTY_PDF, null);
  }

  get url(): string {
    return Utils.getPropertyValue(this.promotion, Utils.PROPERTY_URL, "STRING");
  }
}
